import {
  Flex,
  Image,
  VStack,
  useBreakpointValue,
  Collapse,
  Box,
} from "@chakra-ui/react";
// import { HamburgerIcon, CloseIcon } from "@chakra-ui/icons";
import React, { useState } from "react";
import Logo from "../assets/images/logo.svg";
import TgBtn from "../assets/images/tg-btn.svg";
import CustomHeading from "./CustomHeading";
import HamburgerIcon from "../assets/images/icons8-hamburger-menu.svg";

function Header() {
  // State to track if the burger menu is open
  const [isOpen, setIsOpen] = useState(false);

  // Determine if the screen is small/medium or large using useBreakpointValue
  const isSmallScreen = useBreakpointValue({ base: true, lg: false });

  // Toggle the burger menu
  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <Flex
      pt={{ base: "24px", md: "44px" }}
      justify="space-between"
      align="center"
      maxW={"1250px"}
      mx={"auto"}
      direction="column"
    >
      {/* Top section with logo and buttons */}
      <Flex w="100%" justify="space-between" align="center">
        {/* Logo */}
        <Image src={Logo} alt="Logo" cursor="pointer" draggable={false} />

        {/* Links for large screens */}
        {!isSmallScreen && (
          <Flex align="center" gap="24px">
            <CustomHeading
              text="MANIFESTO"
              size="24px"
              color="#1E1E1E"
              cursor="pointer"
              family="double-bass-regular"
              onClick={() => {
                window.location.href = "#manifesto";
              }}
            />
            <CustomHeading
              text="SOCIAL"
              size="24px"
              color="#1E1E1E"
              cursor="pointer"
              family="double-bass-regular"
              onClick={() => {
                window.location.href = "#follow-us";
              }}
            />
            <CustomHeading
              text="WHITEPAPER"
              size="24px"
              color="#1E1E1E"
              cursor="pointer"
              family="double-bass-regular"
              onClick={() => {
                window.location.href = "#whitepaper";
              }}
            />
            <CustomHeading
              text="TOKENOMICS"
              size="24px"
              color="#1E1E1E"
              cursor="pointer"
              family="double-bass-regular"
              onClick={() => {
                window.location.href = "#tokenomics";
              }}
            />
          </Flex>
        )}
        {!isSmallScreen && (
          <Image
            src={TgBtn}
            alt="Telegram Button"
            height="80px"
            cursor="pointer"
            draggable={false}
          />
        )}
        {/* Burger Button for small/medium screens */}
        {isSmallScreen && (
          <Image
            src={HamburgerIcon}
            alt="hamburger icon"
            onClick={toggleMenu}
            height="32px"
            width="32px"
          />
        )}

        {/* Telegram Button */}
      </Flex>

      {/* Menu for small screens */}
      {isSmallScreen && (
        <Box w={"100%"} color={"#FFFAFF"}>
          <Collapse in={isOpen} animateOpacity>
            <Image
              src={TgBtn}
              alt="Telegram Button"
              mx="auto"
              draggable={false}
              h="80px"
            />
            <VStack
              spacing={4}
              mt={4}
              align="start"
              // bg="gray.100"
              p={4}
              w="100%"
              rounded="md"
              alignItems="center"
            >
              <CustomHeading
                text="MANIFESTO"
                size="20px"
                color="#1E1E1E"
                cursor="pointer"
                family="double-bass-regular"
                onClick={() => {
                  window.location.href = "#manifesto";
                }}
              />
              <CustomHeading
                text="SOCIAL"
                size="20px"
                color="#1E1E1E"
                cursor="pointer"
                family="double-bass-regular"
                onClick={() => {
                  window.location.href = "#follow-us";
                }}
              />
              <CustomHeading
                text="WHITEPAPER"
                size="20px"
                color="#1E1E1E"
                cursor="pointer"
                family="double-bass-regular"
                onClick={() => {
                  window.location.href = "#whitepaper";
                }}
              />
              <CustomHeading
                text="TOKENOMICS"
                size="20px"
                color="#1E1E1E"
                cursor="pointer"
                family="double-bass-regular"
                onClick={() => {
                  window.location.href = "#tokenomics";
                }}
              />
            </VStack>
          </Collapse>
        </Box>
      )}
    </Flex>
  );
}

export default Header;
